import { ProjectsPageCollapsible } from "./ProjectsPageCollapsible";

export default ProjectsPageCollapsible;
